import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../../services/notificationService';
import Button from '../common/Button';
import { Caption, Text, Typography } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

/**
 * ClubJoinRequestRejectedNotificationItem Component
 * Notification item for rejected join requests with rejection message and cooldown info
 */
const ClubJoinRequestRejectedNotificationItem = ({ 
  notification, 
  currentUser,
  onUpdate,
  onClose 
}) => {
  const navigate = useNavigate();
  const notificationData = notification.data || {};
  const clubId = notificationData.club_id;
  const clubName = notificationData.club_name || 'the club';
  const rejectionMessage = notificationData.rejection_message;
  const cooldownUntil = notificationData.cooldown_until;
  const isBlocked = notificationData.is_blocked;

  const handleMarkAsRead = async () => {
    if (notification.id && !notification.is_read) {
      try {
        await markNotificationAsRead(notification.id);
        if (onUpdate) {
          onUpdate();
        }
      } catch (err) {
        console.error('Error marking notification as read:', err);
      }
    }
  };

  const formatCooldownDate = (dateString) => {
    if (!dateString) return null;
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch {
      return null;
    }
  };

  const detailsContent = (
    <>
      {rejectionMessage && (
        <div className="mb-2">
          <Text className="text-text-muted text-sm font-medium mb-1">Rejection Message:</Text>
          <Text className="text-text-secondary text-sm">{rejectionMessage}</Text>
        </div>
      )}
      {isBlocked && (
        <div className="mb-2">
          <Text className="text-red-600 text-sm font-medium">
            ⚠️ You are blocked from requesting to join this club again.
          </Text>
        </div>
      )}
      {cooldownUntil && !isBlocked && (
        <div>
          <div className="text-sm text-text-muted">
            You can submit a new request after:{' '}
            <span className="font-medium text-text-primary">{formatCooldownDate(cooldownUntil)}</span>
          </div>
        </div>
      )}
    </>
  );

  const metadata = clubName && (
    <Caption>Club: {clubName}</Caption>
  );

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor="red"
      badgeVariant="danger"
      detailsContent={detailsContent}
      metadata={metadata}
      onMarkAsRead={handleMarkAsRead}
    />
  );
};

export default ClubJoinRequestRejectedNotificationItem;

